import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { QuickSearchCriteria } from '../../../shared/entities/QuickSearchCriteria';


@Injectable()
export class QueryMessageService {

    private queryMessage = new Subject<QuickSearchCriteria>();
    private enableMode = new Subject<string>();
    private displayQuickSearchCriteria = new Subject<boolean>();
    private queryInvoiceLineItem = new Subject<string>();
    currentInvoiceBalance: number = 0;


    sendMessageToQueryInvoiceLine(invoiceNumberMessage: string): void{
       this.queryInvoiceLineItem.next(invoiceNumberMessage);
    }

    onInvoiceToQueryMessage(): Observable<string>{
        return this.queryInvoiceLineItem.asObservable();
    }

    sendNewQuery(message: QuickSearchCriteria): void{
        this.queryMessage.next(message);
    }

    onQueryMessage(): Observable<QuickSearchCriteria>{
        return this.queryMessage.asObservable();
    }


    setEnableMode(invoiceNumber: string): void{
        this.enableMode.next(invoiceNumber);
    }

    onEnableModeMessage(): Observable<string>{
        return this.enableMode.asObservable();
    }

    setDisplayQuickSearchCriteriaMode(displayQuickSearch: boolean): void{
        this.displayQuickSearchCriteria.next(displayQuickSearch);
    }

    onQuickSearchDisplayModeMessage(): Observable<boolean>{
        return this.displayQuickSearchCriteria.asObservable();
    }
  
   
}